import React, { forwardRef } from "react";
import styles from './Button.module.less';
export const Button = forwardRef(function ({ children, onClick = () => { }, primary, disabled, hidden, style }, ref) {
    return (React.createElement("button", { type: 'button', ref: ref, className: styles.root, onClick: onClick, "data-primary": primary, disabled: disabled ?? false, hidden: hidden, style: style }, children));
});
